import React, { Component } from 'react'
import StudentOrganizationProfileSection from '../components/student_organization_profile/StudentOrganizationProfileSection';
class StudentWiseResult extends Component {
    render() {

        return (
            
               <StudentOrganizationProfileSection
                    hislocationData={this.props.match.params} />

            
        )
    }
}

export default StudentWiseResult
